import TemplateList from './src/index.vue'

/* istanbul ignore next */
TemplateList.install = function (Vue) {
  Vue.component(TemplateList.name, TemplateList)
}

export default TemplateList
